import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';

// styles
import styleHome from '../../Styles/Containers/Home.module.css'


class SettingContainer extends Component{
  constructor(){
    super();
  }

  render(){
    return(
      <div className={styleHome.homeContainer}>
        SettingContainer
      </div>
    )
  }
}

export default connect()(withRouter(SettingContainer))